import React, {Component} from 'react'
import LogHistory from '../../../components/common/LogHistory/LogHistory';

const ApiCallLogsTable = (props) => (
    <LogHistory logName="Api call logs" args={{slApiRequestId: props.match.params.apiCallId}}/>
);


export { ApiCallLogsTable as default };